window.formatShopifyPrice=function(priceCents,currencyCode,locale=navigator.language){if(typeof priceCents!=='number'||isNaN(priceCents))return'';const price=priceCents/100;return new Intl.NumberFormat(locale,{style:'currency',currency:currencyCode,currencyDisplay:'symbol'}).format(price)};function cleanCartListeners(cartElement){const cart=typeof cartElement==='string'?document.querySelector(cartElement):cartElement;if(!cart){console.warn('Cart element not found for cleanup');return null}
const cleanCart=cart.cloneNode(!0);cart.parentNode.replaceChild(cleanCart,cart);return cleanCart}(function(){'use strict';if(window._cartUIInitialized)return;window._cartUIInitialized=!0;function debounce(func,wait){let timeout=null;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait)}}
class ShopifyCartUIGenerator{constructor(){this.cartContainer=document.getElementById('CART');this.stylesInjected=!1;this.lastCartHash=null;this.pendingUpdates=new Map();this.debouncedQuantityUpdate=debounce(this._executeQuantityUpdate.bind(this),300);this.bindEvents()}
bindEvents(){window.addEventListener('updateTopbarAndCart',(event)=>{console.log('updateTopbarAndCart event received',event.detail);this.generateCartUI()})}
_getCartHash(cart){if(!cart||!cart.items)return'';return cart.items.map(item=>`${item.id}:${item.quantity}:${item.final_line_price}`).join('|')+'|'+cart.total_price}
generateCartUI(){console.log('generateCartUI called');if(!this.cartContainer){console.warn('Cart container with ID "CART" not found');return}
const cart=window.shopifyData?.cart;console.log('Current cart data:',cart);if(!cart){console.warn('No cart data available in window.shopifyData');return}
const newHash=this._getCartHash(cart);if(newHash===this.lastCartHash){return}
this.lastCartHash=newHash;const _hadAchieved=!!document.querySelector('.decoy-shipping-bar.achieved');/* HAPTICS */const oldScrollContainer=document.querySelector('.cart-items');const scrollTop=oldScrollContainer?.scrollTop||0;const cartHTML=this.createCartHTML(cart);if(this.cartContainer.innerHTML!==cartHTML){this.cartContainer=cleanCartListeners('#CART');this.cartContainer.innerHTML=cartHTML;this.bindCartEvents();const newScrollContainer=document.querySelector('.cart-items');if(newScrollContainer){newScrollContainer.scrollTop=scrollTop}if(!_hadAchieved&&document.querySelector('.decoy-shipping-bar.achieved')){window._haptics?.trigger('nudge')}/* HAPTICS */}}
createCartHTML(cart){if(!cart.items||cart.items.length===0){return this.createEmptyCartHTML()}
this._updateCartBadges(cart.item_count);return `
                <div class="cart-wrapper">
                    <div class="shopCartButton topbarButton noselect" id="cart_icon" onclick="toggleCart()" style="position: absolute;top: 0;left: 0;z-index: 99999;">
                        <i class="material-icons">shopping_cart</i>
                        <div class="cart_number"><span class="cartNumBubble">${cart.item_count}</span></div>
                    </div>

                    <div class="cart-header">
                        <h3 class="cart-title">CART ⁣‣ ${cart.item_count} ${cart.item_count === 1 ? 'ITEM' : 'ITEMS'}</h3>
                        <div class="cart-buttons-toprow">
                            <button onclick="window._haptics?.trigger('light');/* HAPTICS */window.open('https://decoy.ltd/customer_authentication/redirect', '_blank')" class="orders-btn">ORDERS</button>
                            <button class="cart-clear-btn" data-cart-clear>CLEAR CART</button>
                        </div>
                    </div>

                    <div class="cart-items">
                        ${cart.items.map((item, index) => this.createCartItemHTML(item, index)).join('')}
                    </div>

                    ${(() => {
    const country = window.Shopify?.country;
    const isUS = country === 'US';
    const isUnknown = !country;
    const itemCount = cart.item_count || 0;
    const hasOne = itemCount >= 1;
    const hasTwo = itemCount >= 2;
    const achieved = hasTwo;

    let label;
    if (achieved) {
        label = isUS ? 'FREE SHIPPING + 10% OFF UNLOCKED' : '10% OFF UNLOCKED';
    } else if (hasOne) {
        label = isUS ? 'Add 1 more for FREE SHIPPING + 10% OFF' : 'Add 1 more for 10% OFF';
    } else {
        label = isUS ? 'Add 2 items for FREE SHIPPING + 10% OFF' : 'Add 2 items for 10% OFF';
    }
    if (isUnknown && isUS !== true) label += ' (US: +Free Shipping)';

    return `<div class="decoy-shipping-bar${achieved ? ' achieved' : ''}">
        <div class="shipping-bar__label">${label}</div>
        <div class="shipping-bar__tracks">
            <div class="shipping-bar__track${hasOne ? ' filled' : ''}"></div>
            <div class="shipping-bar__track${hasTwo ? ' filled' : ''}"></div>
        </div>
    </div>`;
})()}

                    <div class="cart-footer">
                        <div class="cart-actions">
                            <div class="cart-subtotal">
                                <div class="cart-subtotal-stats">
                                    <div class="subtotal-row">
                                        <span class="subtotal-label">SUBTOTAL:</span>
                                        <span class="subtotal-amount">${formatShopifyPrice(cart.total_price, shopifyData.cart.currency)}</span>
                                    </div>
                                    ${cart.total_discount > 0 ? `<div class="subtotal-row"><span class="subtotal-label">DISCOUNT:</span><span class="subtotal-amount discount-amount">-${formatShopifyPrice(cart.total_discount,shopifyData.cart.currency)}</span></div>` : ''}
                                    <div class="subtotal-row">
                                        <span class="subtotal-label">SHIPS BY:</span>
                                        <span class="subtotal-amount">${(() => { const d = new Date(Date.now() + 48*60*60*1000); return d.toLocaleDateString('en-US', {month:'short', day:'2-digit'}).toUpperCase(); })()}</span>
                                    </div>
                                </div>
                            </div>
                            <button class="cart-checkout-btn" onclick="window._haptics?.trigger('medium');/* HAPTICS */window.location.href='/checkout'">
                                Checkout
                            </button>
                        </div>
                    </div>
                </div>
                ${this.getCartStyles()}
            `}
createCartItemHTML(item,index){const lineNumber=index+1;const itemImage=(item.featured_image?.url||item.image||'')+'&width=200';const itemImageAlt=(item.featured_image?.alt||item.title||'')+'&width=200';return `
                <div class="cart-item" data-line-item="${lineNumber}">
                    <div class="cart-item-image">
                        ${itemImage
                            ? `<img src="${itemImage}" alt="${itemImageAlt}" loading="lazy">`
                            : '<div class="no-image">No Image</div>'}
                    </div>
                    <div class="cart-item-body">
                        <div class="cart-item-main-row">
                            <h4 class="item-title">${uppercaseQuotedText(item.product_title)}</h4>
                            <div class="cart-item-controls">
                                <div class="qty-spinner">
                                    <button class="qty-arrow qty-up" data-line-item="${lineNumber}" data-quantity="${item.quantity + 1}"><span class="qty-tri">▲</span></button>
                                    <input type="number" class="quantity-input" value="${item.quantity}" min="0" max="999" data-line-item="${lineNumber}">
                                    <button class="qty-arrow qty-down" data-line-item="${lineNumber}" data-quantity="${item.quantity - 1}"><span class="qty-tri">▼</span></button>
                                </div>
                                <span class="line-total">${formatShopifyPrice(item.final_line_price, shopifyData.cart.currency)}</span>
                                <button class="remove-item-btn" data-line-item="${lineNumber}" data-quantity="0"><i class="material-icons ppc-desktop">close</i></button>
                            </div>
                        </div>
                        ${item.variant_title && item.variant_title !== 'Default Title'
                            ? `<p class="item-variant">${item.variant_title}</p>`
                            : ''}
                        ${Object.keys(item.properties || {}).length > 0 ? `<div class="item-properties">${Object.entries(item.properties).map(([key,value])=>value?`<p class="property"><strong>${key}:</strong> ${value}</p>`:'').join('')}</div>` : ''}
                    </div>
                </div>
            `}
createEmptyCartHTML(){this._updateCartBadges(0);return `
                <div class="cart-wrapper">
                    <div class="shopCartButton topbarButton noselect" id="cart_icon" onclick="toggleCart()" style="position: absolute;top: 0;left: 0;z-index: 99999;">
                        <i class="material-icons">shopping_cart</i>
                        <div class="cart_number"></div>
                    </div>

                    <div class="cart-header">
                        <h3 class="cart-title">CART ⁣‣ 0 ITEMS</h3>
                        <div class="cart-buttons-toprow">
                            <button onclick="window.open('https://decoy.ltd/customer_authentication/redirect', '_blank')" class="orders-btn" style="margin-right:0px !important;">ORDERS</button>
                        </div>
                    </div>
                    <div class="cart-items">
                        <div class="cart-empty">
                            <h3>YOUR CART IS EMPTY</h3>
                            <p></p>
                        </div>
                    </div>
                    <div class="cart-footer">
                        <div class="cart-actions">
                            <div class="cart-subtotal">
                                <div class="cart-subtotal-stats">
                                    <div class="subtotal-row">
                                        <span class="subtotal-label">SUBTOTAL:</span>
                                        <span class="subtotal-amount">$0.00</span>
                                    </div>
                                </div>
                            </div>
                            <button class="cart-checkout-btn" onclick="window.location.href='/checkout'" style="background-color:var(--ProductQuiteBright)!important;pointer-events:none!important;">
                                Checkout
                            </button>
                        </div>
                    </div>
                </div>
                ${this.getCartStyles()}
            `}
_updateCartBadges(count){const badges=document.querySelectorAll('.cart_number');for(const badge of badges){badge.innerHTML=count>0?`<span class="cartNumBubble">${count}</span>`:''}}
bindCartEvents(){if(!this.cartContainer)return;this.cartContainer.addEventListener('change',(e)=>{if(e.target.classList.contains('quantity-input')){const lineItem=e.target.dataset.lineItem;const quantity=parseInt(e.target.value)||0;this.queueQuantityUpdate(lineItem,quantity)}});this.cartContainer.addEventListener('click',(e)=>{if(e.target.classList.contains('qty-arrow')){window._haptics?.trigger('selection');/* HAPTICS */const lineItem=e.target.dataset.lineItem;const quantity=parseInt(e.target.dataset.quantity);this.queueQuantityUpdate(lineItem,quantity)}
if(e.target.classList.contains('remove-item-btn')){window._haptics?.trigger('rigid');/* HAPTICS */const lineItem=e.target.dataset.lineItem;this.updateCartItem(lineItem,0)}
if(e.target.classList.contains('cart-clear-btn')){window._haptics?.trigger('heavy');/* HAPTICS */this.clearCart()}})}
queueQuantityUpdate(lineItem,quantity){this.pendingUpdates.set(lineItem,quantity);const itemEl=document.querySelector(`[data-line-item="${lineItem}"]`);if(itemEl){itemEl.classList.add('cartItemPending')}
this.debouncedQuantityUpdate()}
async _executeQuantityUpdate(){if(this.pendingUpdates.size===0)return;const updates=Array.from(this.pendingUpdates.entries());this.pendingUpdates.clear();for(const[lineItem,quantity]of updates){await this.updateCartItem(lineItem,quantity)}}
async updateCartItem(lineItem,quantity){const itemEl=document.querySelector(`[data-line-item="${lineItem}"]`);if(itemEl){itemEl.classList.add('cartItemPending')}
try{const response=await fetch('/cart/change.js?NREC=1',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(lineItem),quantity})});const responseData=await response.json();if(response.ok){window.shopifyData.cart=responseData;window.dispatchEvent(new CustomEvent('updateTopbarAndCart',{detail:{cart:responseData}}))}else{let errorMessage='Failed to update cart item';if(responseData.message){errorMessage=responseData.message}else if(responseData.description){errorMessage=responseData.description}else if(responseData.error){errorMessage=responseData.error}
alert(errorMessage);console.error('Shopify cart update error:',responseData)}}catch(error){alert('Error updating cart item: '+error.message);console.error('Error updating cart item:',error)}finally{if(itemEl){itemEl.classList.remove('cartItemPending')}}}
async clearCart(){const itemEls=document.querySelectorAll('[data-line-item]');for(const itemEl of itemEls){itemEl.classList.add('cartItemPending')}
try{const response=await fetch('/cart/clear.js?NREC=1',{method:'POST'});if(response.ok){const clearedCart=await response.json();window.shopifyData.cart=clearedCart;window.dispatchEvent(new CustomEvent('updateTopbarAndCart',{detail:{cart:clearedCart}}))}else{console.error('Failed to clear cart')}}catch(error){console.error('Error clearing cart:',error)}}
getCartStyles(){if(this.stylesInjected){return''}this.stylesInjected=!0;if(!document.getElementById('decoy-cart-styles')){const s=document.createElement('style');s.id='decoy-cart-styles';s.textContent=`
.cart-wrapper {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}
.cart-items {
  flex: 1 !important;
  height: auto !important;
  min-height: 0 !important;
  overflow-y: auto !important;
}
.cart-footer {
  position: relative !important;
  bottom: auto !important;
  width: 100% !important;
  flex-shrink: 0 !important;
  padding: 16px 0 20px 0 !important;
  box-sizing: border-box !important;
}
.cart-actions {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
}
.cart-checkout-btn {
  white-space: nowrap !important;
  flex-shrink: 0 !important;
}
.cart-subtotal {
  display: flex !important;
  flex-shrink: 0 !important;
}
.cart-subtotal-stats {
  display: flex !important;
  gap: 32px;
  align-items: flex-start;
}
.subtotal-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start !important;
  gap: 4px;
}
.subtotal-label {
  font-size: 14px !important;
  line-height: 1.2 !important;
  letter-spacing: 0.05em;
  opacity: 0.7;
  font-weight: normal !important;
  white-space: nowrap !important;
  text-align: left !important;
}
.subtotal-amount {
  font-size: 28px !important;
  line-height: 1.2 !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: left !important;
}
.discount-amount {
  color: var(--highlight, #0000ff) !important;
}
.decoy-shipping-bar {
  width: 100%;
  padding: 16px 0 12px;
  margin-bottom: 0;
  flex-shrink: 0 !important;
}
.shipping-bar__label {
  font-size: 13px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.08em !important;
  margin-bottom: 10px !important;
  color: var(--AntiValue, #fff) !important;
  opacity: 1 !important;
  text-align: center !important;
  font-weight: normal !important;
}
.shipping-bar__tracks {
  display: flex;
  gap: 8px;
}
.shipping-bar__track {
  flex: 1;
  height: 28px;
  border: 2px solid var(--AntiValue, #fff);
  background: transparent;
  box-sizing: border-box;
  border-radius: 0;
  padding: 4px;
}
.shipping-bar__track::after {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  background: transparent;
  transition: background-color 0.4s ease, box-shadow 0.4s ease;
}
.shipping-bar__track.filled::after {
  background-color: var(--highlight, #0000ff);
}
.decoy-shipping-bar.achieved .shipping-bar__label {
  opacity: 1;
  font-weight: bold !important;
  animation: neon-text 3s linear infinite;
}
.decoy-shipping-bar.achieved .shipping-bar__track.filled::after {
  animation: neon-fill 3s linear infinite;
}
@keyframes neon-cycle {
  0%   { background-color: #00ff41; border-color: #00ff41; box-shadow: 0 0 8px #00ff41; }
  16%  { background-color: #00ffff; border-color: #00ffff; box-shadow: 0 0 8px #00ffff; }
  33%  { background-color: #0080ff; border-color: #0080ff; box-shadow: 0 0 8px #0080ff; }
  50%  { background-color: #bf00ff; border-color: #bf00ff; box-shadow: 0 0 8px #bf00ff; }
  66%  { background-color: #ff00bf; border-color: #ff00bf; box-shadow: 0 0 8px #ff00bf; }
  83%  { background-color: #ff8000; border-color: #ff8000; box-shadow: 0 0 8px #ff8000; }
  100% { background-color: #00ff41; border-color: #00ff41; box-shadow: 0 0 8px #00ff41; }
}
@keyframes neon-fill {
  0%   { background-color: #00ff41; box-shadow: 0 0 6px #00ff41; }
  16%  { background-color: #00ffff; box-shadow: 0 0 6px #00ffff; }
  33%  { background-color: #0080ff; box-shadow: 0 0 6px #0080ff; }
  50%  { background-color: #bf00ff; box-shadow: 0 0 6px #bf00ff; }
  66%  { background-color: #ff00bf; box-shadow: 0 0 6px #ff00bf; }
  83%  { background-color: #ff8000; box-shadow: 0 0 6px #ff8000; }
  100% { background-color: #00ff41; box-shadow: 0 0 6px #00ff41; }
}
@keyframes neon-text {
  0%   { color: #00ff41; text-shadow: 0 0 6px #00ff41; }
  16%  { color: #00ffff; text-shadow: 0 0 6px #00ffff; }
  33%  { color: #0080ff; text-shadow: 0 0 6px #0080ff; }
  50%  { color: #bf00ff; text-shadow: 0 0 6px #bf00ff; }
  66%  { color: #ff00bf; text-shadow: 0 0 6px #ff00bf; }
  83%  { color: #ff8000; text-shadow: 0 0 6px #ff8000; }
  100% { color: #00ff41; text-shadow: 0 0 6px #00ff41; }
}
@media (max-width: 480px) {
  .cart-actions {
    flex-direction: column !important;
    align-items: center !important;
    gap: 16px !important;
  }
  .cart-subtotal {
    width: auto !important;
    align-self: center !important;
  }
  .cart-subtotal-stats {
    display: inline-flex !important;
    gap: 24px;
  }
  .subtotal-row {
    align-items: flex-start !important;
  }
  .subtotal-label {
    text-align: left !important;
  }
  .subtotal-amount {
    text-align: left !important;
  }
  .decoy-shipping-bar {
    width: 80%;
    margin: 0 auto;
  }
}
.cart-item {
  display: flex !important;
  align-items: center !important;
  gap: 1.5vh !important;
  padding: 1.5vh 1vh 1.5vh 0 !important;
  border-bottom: 1px solid color-mix(in srgb, var(--AntiValue, #fff) 8%, transparent) !important;
}
.cart-item-body {
  flex: 1 !important;
  min-width: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 0.4vh !important;
}
.cart-item-main-row {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 1vh !important;
}
.item-title {
  flex: 1 !important;
  min-width: 0 !important;
  margin: 0 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.cart-item-controls {
  display: flex !important;
  align-items: center !important;
  gap: 0 !important;
  flex-shrink: 0 !important;
  padding-right: 0.5vh !important;
}
.qty-spinner {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 0 !important;
  margin-right: 2vh !important;
}
.qty-arrow {
  background: none !important;
  border: none !important;
  color: var(--AntiValue, #fff) !important;
  cursor: pointer !important;
  padding: 0 !important;
  width: 5vh !important;
  height: 1.8vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: color 0.15s !important;
  user-select: none !important;
  line-height: 1 !important;
  overflow: hidden !important;
}
.qty-tri {
  display: inline-block !important;
  font-size: 1.4vh !important;
  line-height: 1 !important;
  transform: scaleX(3.5) !important;
  transform-origin: center !important;
  pointer-events: none !important;
}
.qty-arrow:hover { color: var(--highlight, #0000ff) !important; }
.qty-arrow:active { color: var(--highlight, #0000ff) !important; }
.quantity-input {
  width: 5vh !important;
  background: transparent !important;
  border: 1px solid color-mix(in srgb, var(--AntiValue, #fff) 22%, transparent) !important;
  color: var(--AntiValue, #fff) !important;
  text-align: center !important;
  font-size: 1.8vh !important;
  font-weight: bold !important;
  padding: 0.4vh 0 !important;
  -moz-appearance: textfield !important;
  line-height: 1 !important;
  border-radius: 0 !important;
}
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button { -webkit-appearance: none !important; }
.line-total {
  font-size: 1.8vh !important;
  white-space: nowrap !important;
  margin-right: 2vh !important;
}
.remove-item-btn {
  width: 3.2vh !important;
  height: 3.2vh !important;
  border: 1px solid color-mix(in srgb, var(--AntiValue, #fff) 28%, transparent) !important;
  background: transparent !important;
  color: color-mix(in srgb, var(--AntiValue, #fff) 45%, transparent) !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 1.6vh !important;
  line-height: 1 !important;
  padding: 0 !important;
  flex-shrink: 0 !important;
  transition: border-color 0.2s, color 0.2s, background 0.2s !important;
  border-radius: 0 !important;
  vertical-align: middle !important;
}
.remove-item-btn:hover {
  border-color: var(--highlight, #0000ff) !important;
  color: var(--MainValue, #000) !important;
  background: var(--highlight, #0000ff) !important;
}
`;document.head.appendChild(s)}return''}}

function init(){if(window._cartUIInstance)return;console.log('Initializing ShopifyCartUIGenerator');window._cartUIInstance=new ShopifyCartUIGenerator();if(window.shopifyData?.cart){console.log('Initial cart data found, generating UI');window._cartUIInstance.generateCartUI()}}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}})()